module.exports = "<!-- Signup form -->\r\n<app-pre-login-form [submitText]=\"'Signup'\" (formSubmitted)=\"onSubmit($event)\"></app-pre-login-form>"